<template>
  <div class="helpcenter">
    <Menu v-if="queryP !== 'app'" />
    <div class="bnr">
      <h1 class="title">
        <span class="t1">ToDesk</span>
        <span class="t2">帮助中心</span>
      </h1>
      <h2 class="sub_title">常见问题解答</h2>
    </div>
    <div class="pdn cate">
      <h2 class="title">在下面选择您的产品<br />以获取问题的答案</h2>
      <router-link
        :to="`/helpcenter/solo/index?p=${queryP}`"
        class="cate_item cate_item0"
      >
        <p class="text">个人</p>
        <img src="@/assets/helpcenter/right@2x.png" alt="" class="icon" />
      </router-link>
      <router-link
        :to="`/helpcenter/enterprise/index?p=${queryP}`"
        class="cate_item cate_item1"
      >
        <p class="text">企业级</p>
        <img src="@/assets/helpcenter/right@2x.png" alt="" class="icon" />
      </router-link>
    </div>
    <div class="pdn srch">
      <h1 class="title">您好，<br />我们有什么可以帮助您吗？</h1>
      <div class="srch_cont">
        <img class="icon" src="@/assets/helpcenter/search@2x.png" alt="" />
        <input
          ref="search_input"
          class="put"
          type="text"
          placeholder="搜索您的问题"
          @input="searchInput"
          v-model="search_val"
          @click="getFocus"
        />
        <div class="search_res" v-if="search_res.length > 0">
          <p @click="tosrcres(item.type, item.id)"
            v-for="(item, index) in search_res"
            :key="index"
            class="item"
          >
            {{ item.title }}
          </p>
        </div>
        <div
          class="search_res search_res0"
          v-if="search_res.length == 0 && has_search"
        >
          抱歉，暂时没有您搜索的词条
        </div>
      </div>
    </div>
    <div class="hot_qs" v-if="hot_qs.length">
      <h1 class="title">
        <img class="icon" src="@/assets/helpcenter/faq@2x.png" alt="" />
        <p>热门问题FAQ</p>
      </h1>
      <div class="cont">
        <router-link
          :to="`/helpcenter/questions/${item.id}?p=${queryP}`"
          class="cont_link"
          v-for="(item, index) in hot_qs"
          :key="index"
        >
          <div class="dot"></div>
          <p class="txt">{{ item.title }}</p>
        </router-link>
      </div>
    </div>
    <div class="mention_bx">
      <p class="title">
        <img class="icon" src="@/assets/helpcenter/help@2x.png" alt="" /><span
          >还是找不到解决方案？</span
        >
      </p>
      <div class="link">
        <router-link
          class="linkto"
          :to="`/helpcenter/questions/index?p=${queryP}`"
        >
          <span>了解更多</span>
          <img src="@/assets/helpcenter/right_little@2x.png" alt="" />
        </router-link>
      </div>
    </div>
    <div class="mention_bx mention_bx1">
      <p class="title">
        <img class="icon" src="@/assets/helpcenter/down@2x.png" alt="" /><span
          >下载最新版试试</span
        >
      </p>
      <div class="link">
        <router-link class="linkto" :to="`/download?p=${queryP}`">
          <span>点击立即下载</span>
          <img src="@/assets/helpcenter/right_little@2x.png" alt="" />
        </router-link>
      </div>
    </div>
    <div class="pdn videos" v-if="videos.length">
      <h1 class="title">视频教程</h1>
      <div class="cont">
        <div
          class="item"
          v-for="(item, index) in videos"
          :key="index"
          @click="playVideo(index)"
        >
          <video
            :ref="`video${index}`"
            preload="auto"
            playsinline
            playsinlinex5-video-player-type="h5"
            x5-video-player-fullscreen="true"
            x5-playsinline="true"
            x-webkit-airplay="allow"
            x5-video-orientation="landscape|portrait"
            style="object-fit: fill"
            webkit-playsinline="true"
            x5-video-player-type="h5-page"
            @play="handleFullScreen"
            @ended="handleExitFullScreen"
            :src="item.url"
          ></video>
          <div class="vtitle">
            <p>{{ item.name }}</p>
          </div>
          <img class="play_icon" src="@/assets/helpcenter/play@2x.png" alt="" />
        </div>
      </div>
      <router-link
        class="link"
        :to="`/helpcenter/videoTutorial?p=${queryP}`"
        v-if="re_videos.length > 2"
      >
        <span>查看所有视频</span>
        <img src="@/assets/helpcenter/right_white@2x.png" alt="" />
      </router-link>
    </div>

    <videosH :url="video_bx_url" v-show="showVb" @hide="hideVideoBx" />
    <Footer />
  </div>
</template>
<script>
import Menu from "@/components/menu";
import Footer from "@/components/footer";
import videosH from "@/components/videosH";
export default {
  components: {
    Menu,
    Footer,
    videosH,
  },
  data() {
    return {
      hot_qs: [],
      re_videos: [],
      videos: [],
      search_val: "",
      search_res: [],
      timer: null,
      has_search: false,
      type: "",
      type_str: "",
      video_bx_url: "",
      showVb: false,
      queryP: ''
    };
  },
  async created() {
    let res1 = await this.$serve.getHotQs();
    this.hot_qs = res1.data.list;
    let res2 = await this.$serve.getVideoList();
    this.re_videos = res2.data.list;
    this.videos = res2.data.list.slice(0, 2);
    this.queryP = this.$route.query.p || '';
  },
  methods: {
    handleFullScreen(e) {
      //开始播放
    },
    handleExitFullScreen(e) {
      //播放结束
      e.target.controls = false;
    },
    playVideo(index) {
      this.video_bx_url = this.videos[index].url;
      this.showVb = true;
    },
    hideVideoBx() {
      this.showVb = false;
    },
    searchInput() {
      if (this.search_val.trim().length > 0) {
        this.delayTimer(0);
      } else {
        clearInterval(this.timer);
        this.search_res = [];
        this.has_search = false;
      }
    },
    //防抖
    delayTimer(i) {
      clearInterval(this.timer);
      this.timer = setInterval(() => {
        i++;
        if (i >= 2) {
          this.searchInfo();
          clearInterval(this.timer);
        }
      }, 500);
    },
    async searchInfo() {
      try {
        const res = await this.$serve.searchData({
          title: this.search_val,
        });
        // 过滤掉faq
        this.search_res = res.data.list.filter(item => item.type !== 3);
        this.has_search = true;
        // eslint-disable-next-line no-empty
      } catch (error) {}
    },
    selectWord(title) {
      this.search_val = title;
      this.searchInfo();
    },
    getFocus() {
      this.$refs.search_input.focus();
      this.searchInput();
    },
    tosrcres(type, id) {
      if (type == 0) {
        this.type = 0;
        this.type_str = "questions";
      } else if (type == 1) {
        this.type = 1;
        this.type_str = "solo";
      } else {
        this.type = 2;
        this.type_str = "enterprise";
      }
      this.$router.push(
        `/helpcenter/${this.type_str}/${id}?p=${this.queryP}`
      );
    },
  },
};
</script>
<style lang="less" scoped>
.helpcenter {
  background: #fff;
  .bnr {
    background-image: url("~@/assets/helpcenter/bnr@2x.png");
    background-repeat: no-repeat;
    background-size: cover;
    width: 100%;
    height: 200px;
    text-align: center;
    padding-top: 105px;
    box-sizing: border-box;
    .title {
      font-size: 30px;
      font-family: PingFangSC-Semibold, PingFang SC;
      font-weight: 600;
      .t1 {
        color: #0070f9;
      }
      .t2 {
        color: #1e232a;
      }
    }
    .sub_title {
      margin-top: 2px;
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #585f69;
    }
  }
  .cate {
    background: #f7f8fa;
    .title {
      font-size: 26px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #131314;
      line-height: 37px;
      letter-spacing: 1px;
      text-align: center;
    }
    .cate_item {
      display: flex;
      width: 327px;
      height: 86px;
      background: linear-gradient(180deg, #f6f9ff 0%, #ffffff 100%);
      box-shadow: 0px 11px 15px 0px #e6e8eb;
      border-radius: 10px;
      border: 2px solid #ffffff;
      padding-left: 20px;
      padding-right: 20px;
      box-sizing: border-box;
      align-items: center;
      justify-content: space-between;
      overflow: hidden;
      margin: auto;
      p {
        font-size: 20px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #131314;
      }
      img {
        width: 30px;
        height: 30px;
      }
    }
    .cate_item0 {
      background-image: url("~@/assets/helpcenter/solo_bgi.png");
      background-repeat: no-repeat;
      background-position: 256px 10px;
      margin-top: 30px;
    }
    .cate_item1 {
      background-image: url("~@/assets/helpcenter/ep_bgi.png");
      background-repeat: no-repeat;
      background-position: 248px 12px;
      margin-top: 20px;
    }
  }
  .srch {
    background-color: #fff;
    .title {
      font-size: 26px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #131314;
      line-height: 37px;
      letter-spacing: 1px;
      text-align: center;
    }
    .srch_cont {
      width: 327px;
      height: 52px;
      background: #ffffff;
      box-shadow: 0px 6px 15px 0px #f7f8fa;
      border-radius: 3px;
      border: 1px solid #c2c5cc;
      display: flex;
      align-items: center;
      padding-left: 16px;
      padding-right: 16px;
      box-sizing: border-box;
      margin: auto;
      margin-top: 30px;
      position: relative;
      .icon {
        width: 20px;
        height: 20px;
      }
      .put {
        height: 100%;
        flex: 1;
        margin-left: 6px;
        background: none;
        outline: none;
        border: none;
        font-size: 20px;
        &:focus {
          border: none;
        }
      }
    }
  }
  .hot_qs {
    width: 327px;
    background: #f7f8fa;
    border-radius: 3px;
    padding: 20px;
    box-sizing: border-box;
    margin: auto;
    .title {
      display: flex;
      align-items: center;
      padding-bottom: 20px;
      border-bottom: 1px solid #ccced4;
      .icon {
        width: 26px;
        height: 26px;
      }
      p {
        font-size: 20px;
        font-family: PingFangSC-Semibold, PingFang SC;
        font-weight: 600;
        color: #131314;
        margin-left: 10px;
      }
    }
    .cont {
      padding-top: 30px;
      .cont_link {
        padding-left: 6px;
        display: flex;
        align-items: center;
        margin-bottom: 20px;
        .dot {
          width: 6px;
          height: 6px;
          background: #0b80fe;
          border-radius: 50%;
        }
        .txt {
          margin-left: 8px;
          font-size: 14px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #272727;
        }
        &:active {
          .txt {
            color: #0b80fe;
          }
        }
      }
    }
  }
  .mention_bx {
    width: 327px;
    background: #f7f8fa;
    border-radius: 3px;
    padding: 16px 20px;
    background-image: url("~@/assets/helpcenter/help0_bgi@2x.png");
    background-repeat: no-repeat;
    background-position: right top;
    background-size: auto 100%;
    margin: auto;
    margin-top: 30px;
    box-sizing: border-box;
    .title {
      display: flex;
      align-items: center;
      .icon {
        width: 31px;
        height: 31px;
      }
      span {
        font-size: 20px;
        font-family: PingFangSC-Semibold, PingFang SC;
        font-weight: 600;
        color: #131314;
        margin-left: 8px;
      }
    }
    .link {
      margin-top: 15px;
      text-align: right;
      .linkto {
        span {
          font-size: 14px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #016efd;
          line-height: 20px;
        }
        img {
          margin-left: 6px;
          width: 17px;
          height: auto;
        }
        &:active {
          opacity: 0.8;
        }
      }
    }
  }
  .mention_bx1 {
    background-image: url("~@/assets/helpcenter/help1_bgi@2x.png");
  }
  .videos {
    .title {
      text-align: center;
      font-size: 26px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #1e232a;
    }
    .cont {
      margin-top: 30px;
      display: flex;
      justify-content: center;
      flex-flow: row wrap;
      .item {
        margin-bottom: 10px;
        width: 158px;
        background: #ffffff;
        box-shadow: 0px 0px 9px 0px rgba(0, 0, 0, 0.14);
        border-radius: 4px;
        margin-left: 5px;
        margin-right: 5px;
        position: relative;
        .play_icon {
          position: absolute;
          right: 0;
          display: block;
          top: 0;
          width: 50px;
          height: 50px;
        }
        video {
          width: 100%;
          height: 80px;
          object-fit: fill;
        }
        .vtitle {
          height: 44px;
          padding: 6px 12px;
          display: flex;
          box-sizing: border-box;
          align-items: center;
          p {
            font-size: 13px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #131314;
            line-height: 18px;
            overflow: hidden;
            text-overflow: ellipsis;
            width: 100%;
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 2;
            word-break: break-all;
          }
        }
      }
    }
    .link {
      margin: auto;
      margin-top: 25px;
      display: block;
      width: 164px;
      height: 50px;
      background: #0b80fe;
      border-radius: 7px;
      display: flex;
      align-items: center;
      justify-content: center;
      span {
        font-size: 16px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #ffffff;
      }
      img {
        width: 12px;
        height: auto;
        margin-left: 4px;
      }
    }
  }

  .search_res {
    position: absolute;
    top: 52px;
    left: 0;
    width: 100%;
    padding: 6px 20px 6px 20px;
    box-sizing: border-box;
    background-color: #fff;
    border-bottom: 1px solid #c2c5cc;
    box-shadow: 0px 11px 20px 0px rgba(0, 0, 0, 0.2);
    z-index: 1;
    max-height: 320px;
    overflow: auto;
    .item {
      font-size: 14px;
      margin-bottom: 2px;
      padding-top: 6px;
      padding-bottom: 6px;
      -webkit-line-clamp: 1;
      height: 17px;
      cursor: pointer;
    }
  }
  .search_res0 {
    height: 100px;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #ccced4;
  }
}
</style>
